import React, { useRef } from 'react';
import {
    horizontalPipeStyle,
    pipeContainerStyle,
    textStyle,
    completePipeStyle
} from './LabelledSectionStyles';

const LabelledSection = ({
    id = '',
    height = 11,
    width = 200,
    text = '',
    dockText = 'top',
    containerStyle = {},
    ...props
}) => {
    const textRef = useRef(null);

    return (
        <div id={id} style={pipeContainerStyle(height, width, containerStyle)}>
            {dockText === 'top' && (
                <div
                    style={{
                        border: '1px solid #D7D7D7',
                        position: 'absolute',
                        borderWidth: '0 1px 1px 1px',
                        borderRadius: 8,
                        width: width + 7,
                        height: height
                    }}
                >
                    <div
                        style={horizontalPipeStyle(
                            0,
                            width - 4,
                            textRef?.current?.offsetWidth,
                            4
                        )}
                    />
                    <div
                        style={horizontalPipeStyle(
                            0,
                            width - 12,
                            textRef?.current?.offsetWidth,
                            textRef?.current?.offsetWidth +
                                (width - textRef?.current?.offsetWidth - 10) /
                                    2 +
                                19
                        )}
                    />
                    <span
                        ref={textRef}
                        style={textStyle(
                            0,
                            width,
                            textRef?.current?.offsetWidth
                        )}
                    >
                        {text}
                    </span>
                    <div style={completePipeStyle(height, width, 8)} />
                    <div align='center' style={{ marginTop: height / 4 }}>
                        {props.children}
                    </div>
                </div>
            )}

            {dockText === 'bottom' && (
                <div
                    style={{
                        border: '1px solid #D7D7D7',
                        position: 'absolute',
                        borderWidth: '1px 1px 0 1px',
                        borderRadius: 8,
                        width: width + 7,
                        height: height
                    }}
                >
                    <div
                        style={horizontalPipeStyle(
                            height,
                            width - 4,
                            textRef?.current?.offsetWidth,
                            4
                        )}
                    />
                    <div
                        style={horizontalPipeStyle(
                            height,
                            width - 12,
                            textRef?.current?.offsetWidth,
                            textRef?.current?.offsetWidth +
                                (width - textRef?.current?.offsetWidth - 10) /
                                    2 +
                                19
                        )}
                    />
                    <span
                        ref={textRef}
                        style={textStyle(
                            height,
                            width,
                            textRef?.current?.offsetWidth
                        )}
                    >
                        {text}
                    </span>
                    <div style={completePipeStyle(-1, width, 8)} />
                </div>
            )}
        </div>
    );
};

export default LabelledSection;
